const ProjectsData = [
  {
    id: 0,
    imag: "001.jpeg",
    name: "Healthcare clinic",
    linko: "https://healthcare-nextjs-project.netlify.app",
    tech: [
      "HTML",
      "CSS3",
      "JavaScript",
      "ReactJs",
      "Bootstrap",
      "Sass",
      "NextJs",
      "Git",
      "GitHub",
    ],
    Lan: "English",
    Responsive: "All",
  },
  {
    id: 1,
    imag: "002.jpeg",
    name: "Top rated Movies",
    linko: "https://movie-website-api-ossama.netlify.app",
    tech: [
      "HTML",
      "CSS3",
      "JavaScript",
      "ReactJs",
      "Bootstrap",
      "Sass",
      "Git",
      "GitHub",
    ],
    Lan: "English",
    Responsive: "All",
  },
  {
    id: 2,
    imag: "003.jpeg",
    name: "Foodera Restaurant",
    linko: "https://foodera-ecommerce-restaurant.netlify.app",
    tech: [
      "HTML",
      "CSS3",
      "JavaScript",
      "ReactJs",
      "Bootstrap",
      "Git",
      "GitHub",
    ],
    Lan: "English & Arabic",
    Responsive: "All",
  },
  {
    id: 3,
    imag: "004.jpeg",
    name: "A Personal Website",
    linko: "https://ossama-magdy.netlify.app",
    tech: ["HTML", "CSS3", "JavaScript", "Bootstrap", "Git", "GitHub"],
    Lan: "English",
    Responsive: "Not",
  },
  {
    id: 4,
    imag: "005.jpeg",
    name: "Ecommerce store",
    linko: "https://shopo-tailwind.netlify.app",
    tech: [
      "HTML",
      "CSS3",
      "JavaScript",
      "ReactJs",
      "Bootstrap",
      "Sass",
      "Git",
      "GitHub",
    ],
    Lan: "English",
    Responsive: "All",
  },
  {
    id: 5,
    imag: "006.jpeg",
    name: "Random Portfolio",
    linko: "https://react-randome-portfolio.netlify.app",
    tech: [
      "HTML",
      "CSS3",
      "JavaScript",
      "ReactJs",
      "Bootstrap",
      "Git",
      "GitHub",
    ],
    Lan: "English",
    Responsive: "All",
  },
  {
    id: 6,
    imag: "007.jpeg",
    name: "A very sample Ecommerce Website",
    linko: "https://a-very-sample-e-commerce.netlify.app",
    tech: [
      "HTML",
      "CSS3",
      "JavaScript",
      "ReactJs",
      "Bootstrap",
      "Git",
      "GitHub",
    ],
    Lan: "English",
    Responsive: "All",
  },
  {
    id: 7,
    imag: "008.jpeg",
    name: "A very sample Ecommerce Website",
    linko: "/",
    tech: [
      "HTML",
      "CSS3",
      "JavaScript",
      "ReactJs",
      "Sass",
      "Bootstrap",
      "Git",
      "GitHub",
    ],
    Lan: "English",
    Responsive: "All",
  },
];

export default ProjectsData;
